import { useState } from "react";
import { Mail, Phone, User } from "lucide-react";

// Influencer'a acik olan fatura yukleme / odeme bilgileri formu ekranlarinda
// ortak kullanilan parcalar.

// web/public/newtvLogo-dark.avif yüklenemezse yazı ile fallback gösterilir.
export function BrandHeader() {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <div className="mb-4 flex items-center justify-center border-b pb-4">
      {logoFailed ? (
        <span className="text-lg font-bold tracking-wide text-primary">
          NEW TV GENERATION
        </span>
      ) : (
        <img
          src="/newtvLogo-dark.avif"
          alt="NewTV"
          className="h-9 w-auto object-contain"
          onError={() => setLogoFailed(true)}
        />
      )}
    </div>
  );
}

// Formu dolduran influencer'ın soru sorabilmesi için proje yöneticisi iletişim bilgileri.
export function ManagerContact({ payment }) {
  const name = payment?.managerName || payment?.relatedUser;
  const email = payment?.managerEmail;
  const phone = payment?.managerPhone;

  if (!name && !email && !phone) return null;

  return (
    <div className="rounded-md border bg-muted/40 p-3">
      <p className="text-xs font-medium text-muted-foreground">
        İlgili Proje Yöneticisi
      </p>
      <div className="mt-2 space-y-1.5 text-sm">
        {name && (
          <div className="flex items-center gap-2">
            <User className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
            <span>{name}</span>
          </div>
        )}
        {email && (
          <div className="flex items-center gap-2">
            <Mail className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
            <a
              className="break-all text-muted-foreground hover:text-foreground hover:underline"
              href={`mailto:${email}`}
            >
              {email}
            </a>
          </div>
        )}
        {phone && (
          <div className="flex items-center gap-2">
            <Phone className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
            <a
              className="text-muted-foreground hover:text-foreground hover:underline"
              href={`tel:${phone}`}
            >
              {phone}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

// Formun ustundeki ozet satirlari (ödeme adi, e-posta, tutar).
export function SummaryRow({ label, value, emphasis = false }) {
  if (value === undefined || value === null || value === "") return null;

  return (
    <div className="flex items-baseline justify-between gap-4 py-2">
      <span className="text-sm text-muted-foreground">{label}</span>
      <span
        className={
          emphasis
            ? "text-lg font-semibold tabular-nums"
            : "text-sm font-medium text-right break-all"
        }
      >
        {value}
      </span>
    </div>
  );
}

export function SummaryList({ children }) {
  return <div className="divide-y rounded-md border px-3">{children}</div>;
}
